import { render, staticRenderFns } from "./formdialog.vue?vue&type=template&id=b9b21910&scoped=true"
import script from "./formdialog.vue?vue&type=script&lang=js"
export * from "./formdialog.vue?vue&type=script&lang=js"
import style0 from "./formdialog.vue?vue&type=style&index=0&id=b9b21910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b21910",
  null
  
)

export default component.exports